import { render, staticRenderFns } from "./nameTile.table.vue?vue&type=template&id=383b2f0d&"
import script from "./nameTile.table.vue?vue&type=script&lang=js&"
export * from "./nameTile.table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports